<template>
  <div class="full-height">
    <div>
      <h2>
        {{ $t("portal.public_layout.welcome") }}<br />{{
          $t("portal.public_layout.oscilos")
        }}
      </h2>
      <DxButton @click="doEnter" type="default" class="d-flex">{{
        $t("shared.ui.buttons.access")
      }}</DxButton>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from "@/.shared/services/routing-services";
import { useAuthentication } from "@services/auth/authentication";
import DxButton from "devextreme-vue/button";

const props = defineProps<{ redirectTo?: string }>();
const router = useRouter();
const auth = useAuthentication();

function doEnter() {
  if (auth.isLoggedIn()) {
    if (props.redirectTo) router.replace(props.redirectTo);
    else router.replace({ name: "private-home" });
  } else {
    auth.login(`${import.meta.env.BASE_URL}${props.redirectTo ?? ""}`);
  }
}
</script>
<style scoped lang="scss">
@import "@/styles/_vars.scss";
@import "@/styles/figma.scss";
@import "@/styles/_themevars.scss";

.full-height {
  background: var(--background-default-page);
  background-size: cover;
  height: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  width: 100%;


  h2 {
    color: var(--text-primary-default);
    text-align: center;
    font-family: var(--font-family-headings);
    font-size: var(--font-size-heading-h2);
    font-style: normal;
    font-weight: 600;
    line-height: var(--line-height-heading-h2);
    /* 116.667% */
  }

  >div {
    display: flex;
    width: 400px;
    padding: var(--spacing-xl);
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-md);
    border-radius: var(--border-radius-xl);
    background: var(--background-default-default);
    /* Shadow-components */
    box-shadow: 0px 4px 4px 0px rgba(36, 36, 36, 0.10);
  }

  #shared-common {
    height: 100%;
  }

  .dx-widget.dx-button.dx-button-mode-contained.dx-button-default.d-flex {
    width: 100%;
  }
}
</style>
